import { FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCampaignsActions } from '../context';
import { CreateCampaignFormInput, CreateCampaignFormOutput } from '../validation';
import { CampaignSummaryItem, CampaignSummaryItemField } from './CampaignSummaryItem';
import { CampaignStepSummaryProps } from './CampaignSummarySection';

export const DestinationStepSummary: FC<CampaignStepSummaryProps> = ({ isStepCompleted }) => {
  const { t } = useTranslation();

  const { setStep } = useCampaignsActions();
  const { control } = useFormContext<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>();

  const destinations = useWatch({
    control,
    name: 'connectors',
  });

  const destination = destinations.at(destinations.length - 1);

  const content = useMemo<CampaignSummaryItemField[]>(() => {
    if (!destination) {
      return [];
    }

    return [{ field: t('COMMON:name'), value: destination?.connector?.name }];
  }, [destination]);

  return (
    <CampaignSummaryItem
      index={3}
      title={t('ALL:destinationSummary')}
      content={content}
      label={destination?.connector?.installed && destination?.connector?.authenticated ? t('ALL:connected') : undefined}
      {...(isStepCompleted && { onClick: () => setStep('ChooseDestination') })}
    />
  );
};
